import { IconMapPin, IconSailboat, IconScubaMask } from '@tabler/icons-react';

export const getSearchIcon = (type: number) => {
  switch (type) {
    case 1:
      return <IconMapPin size={20} />;
    case 2:
      return <IconScubaMask size={20} />;
    case 3:
      return <IconSailboat size={20} />;
    default:
      return <IconMapPin size={20} />;
  }
};

export const getSearchType = (type: number) => {
  switch (type) {
    case 1:
      return 'Country';
    case 2:
      return 'Destination';
    case 3:
      return 'Liveaboard';
    default:
      return 'Country';
  }
};
